// Source
import * as Instance from "../Instance";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelPayment from "../../model/custom/Payment";

export const createDataPi = (name: string, clientId: number, date: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        name,
        client_id: clientId,
        date
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/payment/create_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const updateDataPi = (id: number, name: string, clientId: number, date: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        id,
        name,
        client_id: clientId,
        date
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/payment/update_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const removeData = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/payment/remove_data",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const validationForm = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/payment/validation_form", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const dataList = (
    mode: string,
    dataMain: ModelPayment.Idata,
    sortOrder: string,
    page: string,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        sort_order: sortOrder,
        page: page,
        mode: mode,
        date: dataMain.date,
        client_id: dataMain.client_id as unknown as string,
        latest_update: dataMain.latest_update,
        latest_update_by_id: dataMain.latest_update_by_id as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/payment/data_list?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const selectOption = (mode: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        mode: mode
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/payment/select_option?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const invoiceDataList = (sortOrder: string, page: string, id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        sort_order: sortOrder,
        page: page,
        id: id as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/payment/invoice_data_list?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const create_pi = (id: number, invoice: Record<string, unknown>, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        id,
        invoice
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/payment/create_pi`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const create_pd = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/payment/create_pd`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const payerLimit = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        id: id as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/payment/payer_limit?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};
